import { makeAutoObservable, autorun } from "mobx";

export default class SideBarStore {
  selection = "events";
  width;
  eventsScrollTop;
  constructor() {
    makeAutoObservable(this);
    autorun(() => {
      sessionStorage[`monitorSidebar_${sessionStorage.listIndex}`] =
        JSON.stringify(this);
    });
    try {
      Object.assign(
        this,
        JSON.parse(
          sessionStorage[`monitorSidebar_${sessionStorage.listIndex}`],
        ),
      );
    } catch (e) {
      if (e.name !== "SyntaxError") console.error(e);
    }
  }
}
